module.exports = __webpack_public_path__ + "static/media/5-shane.759c0517.png";